import dotProp from 'dot-prop-immutable';
import * as types from 'live/redux/actionTypes';

const defaultState = {
  section: undefined,
};

const uiReducer = (state = defaultState, action = {}) => {
  switch (action.type) {
    case types.LIVE_SET_SECTION: {
      const section = action.payload;
      return dotProp.set(state, 'section', section);
    }

    default:
      return state;
  }
};

export default uiReducer;
